// import React, {useState} from 'react';
// import logo from "../assetes/logo.png";
// import ReactSignatureCanvas from 'react-signature-canvas';
// import { FaRepeat } from "react-icons/fa6";
// import { FaCheck } from "react-icons/fa";
// import { request } from '../utils/request';
// import { useDispatch, useSelector } from 'react-redux';
// import { accidentAction } from '../redux/slices/accidentSlice';
// import { toast } from 'react-toastify';
// import {ClipLoader} from "react-spinners"
// import { useNavigate } from 'react-router-dom';
// function AddPartner() {
//   const {createPhotoLoading} = useSelector(state => state.accident)
//   const [sign, setSign] = useState();
//   const [url, setUrl] = useState('');
//   const [formData, setFormData] = useState({
//       name: '',
//       address: '',
//       city: '',
//       iban: '',
//       accountInfo: '',
//       username: '',
//       password: '',
//       phoneNumber: '',
//       email: '',
//       description: '',
//   });

//   const handleClear = () => {
//       sign.clear();
//       setUrl('');
//       setFormData({
//           name: '',
//           address: '',
//           city: '',
//           iban: '',
//           accountInfo: '',
//           username: '',
//           password: '',
//           phoneNumber: '',
//           email: '',
//           description: '',
//           image:null
//       });
//   };

//   const handleGenerate = () => {
//       const trimmedCanvas = sign.getTrimmedCanvas();
//       if (trimmedCanvas) {
//           setUrl(trimmedCanvas.toDataURL('image/png'));
//       }
//   };

//   const handleChange = (e) => {
//       const { name, value } = e.target;
//       if(name==="image"){
//         setFormData({ ...formData, [name]: e.target.files[0] });
//       }else {
//         setFormData({ ...formData, [name]: value });
//       }
//   };
//   const dispatch = useDispatch()
//   const navigate = useNavigate()
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const data = new FormData();
//     Object.keys(formData).forEach(key => {
//         data.append(key, formData[key]);
//     });
//     if (url) {
//       data.append('image', url);
//     }
  
//     try {
//       dispatch(accidentAction.setCreatePhotoLoading(true))
//       const response = await request.post('/auth/register', data, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       toast.success("User created successfully");
//       dispatch(accidentAction.setCreatePhotoLoading(false));
//       navigate("/partner");
//     } catch (error) {
//       dispatch(accidentAction.setCreatePhotoLoading(false));
      
//       // التحقق من وجود error.response أولاً
//       const errorMessage = error.response?.data?.message || "An error occurred";
//       toast.error(errorMessage);
      
//       console.error('Error creating user:', error);
//     }
//   };

//   const user = JSON.parse(sessionStorage.getItem("user"));
//   return (
//     <div className='flex flex-col w-full h-screen overflow-y-auto hidden-scrollbar px-2 md:px-0'>
//       <div className="pl-2 md:pl-5 flex flex-col md:flex-row justify-between w-full pt-9 items-center ">
//         <div>
//           <h1 className="font-montserrat text-xl md:text-2xl font-bold">Neuen Partner erstellen</h1>
//         </div>
//         <div className="flex items-center mt-2 md:mt-0">
//           <div className="text-center md:text-right">
//             <h4 className="text-sm">{user.username}</h4>
//             <p className="text-xs text-gray-600">{user.role}</p>
//           </div>
//           <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-gray-800 ml-2">
//             <img src={user.profilePhoto?.url} alt="img-pro" className="w-full h-full rounded-full" />
//           </div>
//         </div>
//       </div>
//       <div className="border-b border-black w-full mt-3"></div>

//       <div className="bg-gray-100 p-4 md:p-8">
//         <h1 className="text-lg md:text-2xl font-bold mb-4">Füllen Sie bitte folgende Informationen</h1>
//         <form className="flex flex-col space-y-4">
//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Name</label>
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>

//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Adresse</label>
//             <input
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>

//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Ort:</label>
//             <input
//               type="text"
//               name="city"
//               value={formData.city}
//               onChange={handleChange}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>

//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">IBAN</label>
//             <input
//               type="text"
//               name="iban"
//               value={formData.iban}
//               onChange={handleChange}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>

//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Bankdaten</label>
//             <input
//               type="text"
//               name="accountInfo"
//               value={formData.accountInfo}
//               onChange={handleChange}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>

//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Benutzername</label>
//             <input
//               type="text"
//               name="username"
//               value={formData.username}
//               onChange={handleChange}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>

//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Passwort</label>
//             <input
//               type="text"
//               name="password"
//               value={formData.password}
//               onChange={handleChange}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>

//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Telefonnummer</label>
//             <input
//               type="text"
//               name="phoneNumber"
//               value={formData.phoneNumber}
//               onChange={handleChange}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>

//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Email-Adresse</label>
//             <input
//               type="text"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>

//           <div className="flex flex-col w-full">
//             <label className="font-bold w-full mb-2">PROFILE FOTOS:</label>
//             <input
//               name="image"
//               onChange={handleChange}
//               type="file"
//               className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border file:border-gray-300 file:text-sm file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
//             />
//           </div>

//           <div className="flex flex-col w-full">
//             <label className="font-bold w-full mb-2">Bemerkungen</label>
//             <textarea
//               name="description"
//               value={formData.description}
//               onChange={handleChange}
//               className="w-full rounded-lg p-2 focus:outline-none border border-gray-300 bg-[#c8e8ef] resize-none"
//               rows="3"
//             ></textarea>
//           </div>

//           <div className="flex justify-center pb-8">
//             <button 
//               onClick={handleSubmit} 
//               className="w-full md:w-40 bg-[rgb(255,222,89)] border border-black rounded-lg py-4 px-6 flex justify-center items-center " 
//               disabled={createPhotoLoading}
//             >
//               {createPhotoLoading ? (
//                 <ClipLoader size={20} color="#000" />
//               ) : (
//                 "Erstellen"
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }


// export default AddPartner;



import React, { useState } from 'react';
import logo from "../assetes/logo.png";
import ReactSignatureCanvas from 'react-signature-canvas';
import { FaRepeat } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa";
import { request } from '../utils/request';
import { useDispatch, useSelector } from 'react-redux';
import { accidentAction } from '../redux/slices/accidentSlice';
import { toast } from 'react-toastify';
import { ClipLoader } from "react-spinners";
import { useNavigate } from 'react-router-dom';

function AddPartner() {
  const { createPhotoLoading } = useSelector(state => state.accident);
  const [sign, setSign] = useState();
  const [url, setUrl] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    city: '',
    iban: '',
    accountInfo: '',
    username: '',
    password: '',
    phoneNumber: '',
    email: '',
    description: '',
  });

  const handleClear = () => {
    sign.clear();
    setUrl('');
    setFormData({
      name: '',
      address: '',
      city: '',
      iban: '',
      accountInfo: '',
      username: '',
      password: '',
      phoneNumber: '',
      email: '',
      description: '',
      image: null
    });
  };

  const handleGenerate = () => {
    const trimmedCanvas = sign.getTrimmedCanvas();
    if (trimmedCanvas) {
      setUrl(trimmedCanvas.toDataURL('image/png'));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "image") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // تصفية الحقول الفارغة
    const filteredData = Object.keys(formData).reduce((acc, key) => {
      if (formData[key] !== '' && formData[key] !== null && formData[key] !== undefined) {
        acc[key] = formData[key];
      }
      return acc;
    }, {});
  
    // إضافة الصورة إذا كانت موجودة
    if (url) {
      filteredData.image = url;
    }
  
    const data = new FormData();
    Object.keys(filteredData).forEach(key => {
      data.append(key, filteredData[key]);
    });
  
    try {
      dispatch(accidentAction.setCreatePhotoLoading(true));
      const response = await request.post('/auth/register', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success("User created successfully");
      dispatch(accidentAction.setCreatePhotoLoading(false));
      navigate("/partner");
    } catch (error) {
      dispatch(accidentAction.setCreatePhotoLoading(false));
      const errorMessage = error.response?.data?.message || "An error occurred";
      toast.error(errorMessage);
      console.error('Error creating user:', error);
    }
  };

  const user = JSON.parse(sessionStorage.getItem("user"));
  return (
    <div className='flex flex-col w-full h-screen overflow-y-auto hidden-scrollbar px-2 md:px-0'>
      <div className="pl-2 md:pl-5 flex flex-col md:flex-row justify-between w-full pt-9 items-center ">
        <div>
          <h1 className="font-montserrat text-xl md:text-2xl font-bold">Neuen Partner erstellen</h1>
        </div>
        <div className="flex items-center mt-2 md:mt-0">
          <div className="text-center md:text-right">
            <h4 className="text-sm">{user.username}</h4>
            <p className="text-xs text-gray-600">{user.role}</p>
          </div>
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-gray-800 ml-2">
            <img src={user.profilePhoto?.url} alt="img-pro" className="w-full h-full rounded-full" />
          </div>
        </div>
      </div>
      <div className="border-b border-black w-full mt-3"></div>

      <div className="bg-gray-100 p-4 md:p-8">
        <h1 className="text-lg md:text-2xl font-bold mb-4">Füllen Sie bitte folgende Informationen</h1>
        <form className="flex flex-col space-y-4" onSubmit={handleSubmit}>
          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Name <span className="text-red-500">*</span></label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              autocomplete="off"
              required
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Adresse</label>
            <input
              name="address"
              value={formData.address}
              onChange={handleChange}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              autocomplete="off"
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Ort:</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              autocomplete="off"
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">IBAN</label>
            <input
              type="text"
              name="iban"
              value={formData.iban}
              onChange={handleChange}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              autocomplete="off"
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Bankdaten</label>
            <input
              type="text"
              name="accountInfo"
              value={formData.accountInfo}
              onChange={handleChange}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              autocomplete="off"
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Benutzername <span className="text-red-500">*</span></label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              required
              autocomplete="off"
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Passwort <span className="text-red-500">*</span></label>
            <input
              type="text"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              required
              autocomplete="off"
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Telefonnummer</label>
            <input
              type="text"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              autocomplete="off"
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Email-Adresse <span className="text-red-500">*</span></label>
            <input
              type="text"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              required
              autocomplete="off"
            />
          </div>

          <div className="flex flex-col w-full">
            <label className="font-bold w-full mb-2">PROFILE FOTOS:</label>
            <input
              name="image"
              onChange={handleChange}
              type="file"
              className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border file:border-gray-300 file:text-sm file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
            />
          </div>

          <div className="flex flex-col w-full">
            <label className="font-bold w-full mb-2">Bemerkungen</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w-full rounded-lg p-2 focus:outline-none border border-gray-300 bg-[#c8e8ef] resize-none"
              rows="3"
              autocomplete="off"
            ></textarea>
          </div>

          <div className="flex justify-center pb-8">
            <button
              type="submit"
              className="w-full md:w-40 bg-[rgb(255,222,89)] border border-black rounded-lg py-4 px-6 flex justify-center items-center "
              disabled={createPhotoLoading}
            >
              {createPhotoLoading ? (
                <ClipLoader size={20} color="#000" />
              ) : (
                "Erstellen"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddPartner;